import { lazyFindWeatherLocationFromPostalAddress } from 'owa-weather-option';
import { getWeatherService, WeatherForecastResultType } from 'owa-weather';
import type LocationCommonWellItemViewState from 'owa-location-common-well/lib/store/schema/LocationCommonWellItemViewState';
import type WeatherLocationType from 'owa-service/lib/contract/WeatherLocationType';
import type WeatherLocationId from 'owa-service/lib/contract/WeatherLocationId';
import WeatherTemperatureUnit from 'owa-service/lib/contract/WeatherTemperatureUnit';
import TemperatureUnit from 'owa-service/lib/contract/TemperatureUnit';

export default async function getWeatherForLocation(
    selectedLocation: LocationCommonWellItemViewState,
    weatherUnit: WeatherTemperatureUnit
): Promise<WeatherForecastResultType | null> {
    const findWeatherLocationFromPostalAddress = await lazyFindWeatherLocationFromPostalAddress.import();
    return findWeatherLocationFromPostalAddress(selectedLocation.persona.postalAddress).then(
        (location: WeatherLocationType) => {
            if (!location) {
                return null;
            }

            return getWeatherService(convertTemperatureUnit(weatherUnit!), [
                convertToWeatherLocationId(location),
            ]);
        }
    );
}

function convertToWeatherLocationId(location: WeatherLocationType): WeatherLocationId {
    const latitude = location.Latitude && parseFloat(location.Latitude);
    const longitude = location.Longitude && parseFloat(location.Longitude);
    return {
        EntityId: location.LocationId,
        Name: location.Name,
        ...(latitude != null &&
            longitude != null && {
                Latitude: latitude && isNaN(latitude) ? 0 : latitude,
                Longitude: longitude && isNaN(longitude) ? 0 : longitude,
            }),
    } as WeatherLocationId;
}

function convertTemperatureUnit(unit: WeatherTemperatureUnit): TemperatureUnit {
    return unit === WeatherTemperatureUnit.Celsius
        ? TemperatureUnit.Celsius
        : TemperatureUnit.Fahrenheit;
}
